import styled from 'styled-components';

export const HamburgerButton = styled.button<{ $breakPoint: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  @media only screen and (min-width: ${({ $breakPoint }) => $breakPoint + 1}px) {
    display: none;
  }
`;
